import { Slot } from '@radix-ui/react-slot'
import type { ComponentProps } from 'react'

export type ActionPrimitiveProps = ComponentProps<'button'> & {
  asChild?: boolean
}

function ActionPrimitive({ asChild = false, type = 'button', ...props }: ActionPrimitiveProps) {
  const Component = asChild ? Slot : 'button'

  return <Component {...props} type={asChild ? undefined : type} />
}

export { ActionPrimitive }
